import { render, staticRenderFns } from "./SurveyManagementEdit.vue?vue&type=template&id=45c928f0&scoped=true&"
import script from "./SurveyManagementEdit.vue?vue&type=script&lang=js&"
export * from "./SurveyManagementEdit.vue?vue&type=script&lang=js&"
import style0 from "./SurveyManagementEdit.vue?vue&type=style&index=0&id=45c928f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c928f0",
  null
  
)

/* custom blocks */
import block0 from "./SurveyManagementEdit.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45c928f0')) {
      api.createRecord('45c928f0', component.options)
    } else {
      api.reload('45c928f0', component.options)
    }
    module.hot.accept("./SurveyManagementEdit.vue?vue&type=template&id=45c928f0&scoped=true&", function () {
      api.rerender('45c928f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/survey-management/SurveyManagementEdit.vue"
export default component.exports